<template>
    <div>
        <myPage :max_flag="true">
            <div class="flex-box nopadding wrap pd-left5 pd-bottom5" slot="header">
                <el-button-group class="mg-right5 mg-top5 flex-box nopadding">
                    <el-button size="small" :title="$t('refs')" icon="el-icon-refresh" @click="list()"></el-button>
                    <el-button size="small" @click="exportExcel" :title="$t('export')" icon="el-icon-download"></el-button>
                </el-button-group>
                <div class="f-bd f14 text-nowrap">账期{{$t('x_mh')}}</div>
                <div class="mg-right5 mg-top5"><myDatePicker v-model="search.datearea_id" @onChange="onDateChange"></myDatePicker></div>
                <div class="mg-right5 mg-top5">
                    <div class="text-hd small only">
                        <el-checkbox v-model="search.show_ok_flag" true-label="1" false-label="0" @change="refsTable()">仅显示成功</el-checkbox>
                    </div>
                </div>
                <div class="mg-top5"><el-button size="small" @click="list()">{{$t('list')}}</el-button></div>
            </div>
            <div class="fillw fillh">
                <el-table ref="my_table" :data="listData" class="fillw show-scroll" height="100%">
                    <el-table-column fixed :label="listHeader.vendor_cname" min-width="180px">
                        <el-table-column label-class-name="f-red pd-top0" min-width="180px">
                            <div slot-scope="scope" slot="header">合计</div>
                            <div class="f-bd" slot-scope="scope">{{scope.row.vendor_cname}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column fixed :label="listHeader.goods_cname" prop="goods_cname" min-width="150px"></el-table-column>
                    <el-table-column :label="listHeader.goods_id" prop="goods_id" width="90px"></el-table-column>
                    <el-table-column :label="listHeader.mac_goods_id" prop="mac_goods_id" width="120px"></el-table-column>
                    <el-table-column :label="listHeader.order_qty">
                        <el-table-column label-class-name="f-red pd-top0" min-width="120px">
                            <div slot-scope="scope" slot="header">{{totalData.sum.order_qty * 1}}</div>
                            <div class="f-bd f-red" slot-scope="scope">{{scope.row.order_qty * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.goods_amt">
                        <el-table-column label-class-name="f-red pd-top0" min-width="140px">
                            <div slot-scope="scope" slot="header">{{totalData.sum.goods_amt * 1}}</div>
                            <div class="f-bd f-red" slot-scope="scope">{{scope.row.goods_amt * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.cost_amt">
                        <el-table-column label-class-name="f-red pd-top0" min-width="140px">
                            <div slot-scope="scope" slot="header">{{totalData.sum.cost_amt * 1}}</div>
                            <div class="f-bd f-red" slot-scope="scope">{{scope.row.cost_amt * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.cr_cat10_qty">
                        <el-table-column label-class-name="f-red pd-top0" min-width="120px">
                            <div slot-scope="scope" slot="header">{{totalData.sum.cr_cat10_qty * 1}}</div>
                            <div class="f-bd f-red" slot-scope="scope">{{scope.row.cr_cat10_qty}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.cr_cat20_qty">
                        <el-table-column label-class-name="f-red pd-top0" min-width="140px">
                            <div slot-scope="scope" slot="header">{{totalData.sum.cr_cat20_qty * 1}}</div>
                            <div class="f-bd f-red" slot-scope="scope">{{scope.row.cr_cat20_qty * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                    <template v-if="search.show_ok_flag == '0'">
                    <el-table-column :label="listHeader.fail_order_qty">
                        <el-table-column label-class-name="f-red pd-top0" min-width="120px">
                            <div slot-scope="scope" slot="header" class="f-blue">{{totalData.sum.fail_order_qty * 1}}</div>
                            <div class="f-bd f-blue" slot-scope="scope">{{scope.row.fail_order_qty * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                        <el-table-column :label="listHeader.fail_goods_amt">
                            <el-table-column label-class-name="f-red pd-top0" min-width="140px">
                                <div slot-scope="scope" slot="header" class="f-blue">{{totalData.sum.fail_goods_amt * 1}}</div>
                                <div class="f-bd f-blue" slot-scope="scope">{{scope.row.fail_goods_amt * 1}}</div>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column :label="listHeader.wait_order_qty">
                            <el-table-column label-class-name="f-red pd-top0" min-width="120px">
                                <div slot-scope="scope" slot="header" class="f-black">{{totalData.sum.wait_order_qty * 1}}</div>
                                <div class="f-bd" slot-scope="scope">{{scope.row.wait_order_qty * 1}}</div>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column :label="listHeader.wait_goods_amt">
                            <el-table-column label-class-name="f-red pd-top0" min-width="140px">
                                <div slot-scope="scope" slot="header" class="f-black">{{totalData.sum.wait_goods_amt * 1}}</div>
                                <div class="f-bd" slot-scope="scope">{{scope.row.wait_goods_amt * 1}}</div>
                            </el-table-column>
                        </el-table-column>
                    </template>
                    <el-table-column :label="listHeader.date_no" prop="date_no" width="220px"></el-table-column>
                    <el-table-column :label="listHeader.upd_time" prop="upd_time" width="170px"></el-table-column>
                </el-table>
            </div>
            <div slot="footer">
                <myPager slot="footer" :limit="search.limit" @onLimitChange="onLimitChange"
                         v-model="search.page" :pageSize="search.pageSize" @onPagerChange="onPagerChange"></myPager>
            </div>
        </myPage>
    </div>
</template>

<script>
import myPager from '../../../components/myPager'
import myDatePicker from "../../../components/myDatePicker";
import excel from '../../../utils/excel'
export default {
    name:'report-vendorsumgoods',
    components:{
        myPager,
        myDatePicker
    },
    data: function(){
        const listHeader = {
            vendor_cname: '供应商名称',
            goods_cname: '商品名称',
            goods_id: '平台商品ID',
            mac_goods_id: '供应商产品ID',
            order_qty: '成功单量',
            goods_amt: '成功面值额',
            cost_amt: '成功结算价',
            cr_cat10_qty: '信誉按单量消耗',
            cr_cat20_qty: '信誉按面额消耗',
            fail_order_qty: '失败单量',
            fail_goods_amt: '失败面值额',
            wait_order_qty: '未完成单量',
            wait_goods_amt: '未完成面值额',
            date_no: "账期",
            upd_time: '结算时间'
        }
        return{
            relist: false,
            excel_frow_num: 2, //固定两行
            excel_fcol_num: 2, //固定三列
            search:{
                search_url: 'report-vendor-sum/list-goods',
                datearea_id:7,//如果大于0 mounted 要删除date_fr date_to
                date_fr: '',
                date_to: '',
                page: 1,
                pageSize: 0,
                limit:'30',
                show_ok_flag:'1'
            },
            listHeader,
            listData:[],
            totalData: {
                total: 0,//总行数
                sum:{}
            },
        }
    },
    activated:function(){
        this.$base.setMenuOpens();
    },
    mounted:function(){
        this.$base.setMenuOpens();
        this.$base.listPageInit(this,()=>{
            this.list();
        });
    },
    methods: {
        refsTable:function (){
            this.$nextTick(()=>{
                this.$refs.my_table.doLayout();
                this.list();
            });
        },
        onDateChange: function(data){
            this.search.date_fr = data[0];
            this.search.date_to = data[1];
        },
        onPagerChange: function () {
            this.list(true);
        },
        onLimitChange: function (limit) {
            this.search.limit = limit;
            this.list();
        },
        list: function (change_page) {
            this.$base.list(this, change_page);
        },
        exportExcel: function(){
            // this.$base.exportExcel(this);
            excel.exportExcel(this);
        },
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/report/vendorsumgoods/list.vue